import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import React from "react";
import { getStorageData } from "framework/src/Utilities";
import { isAuthenticated, scrollToTop } from "../../../components/src/utils";
import { InfoType } from "../../../components/src/CustomInfoDialog.web";

declare global {
  interface Window {
    Razorpay: new (options: RazorpayOptions) => RazorpayInstance;
  }
}

interface RazorpayPaymentFailedResponse {
  error: {
    code: string;
    description: string;
    reason: string;
    metadata: {
      order_id?: string;
      payment_id?: string;
    };
  };
}

interface RazorpayOptions {
  key: string;
  subscription_id: string;
  name: string;
  description: string;
  prefill: {
    name: string;
    email: string;
    contact: string;
  };
  theme: {
    color: string;
  };
  handler: (response: RazorpayResponse) => void;
}

interface RazorpayInstance {
  open: () => void;
  close: () => void
  on: (
    event: string,
    callback: (response: RazorpayPaymentFailedResponse) => void
  ) => void
}

interface RazorpayResponse {
  razorpay_payment_id: string;
}

interface IOrderDetails {
  id: string
  type: string
  attributes: {
    id: number
    order_number: string
    status: string
    total: number
    gst: number
    sub_total: number
    valid_date: string
    active_plan: boolean
    order_date: string
    auto_renewal: boolean
    subscription: {
        id: number
        name: string
        price: string
    },
    account: {
        id: number
        full_name: string
        email: string
    }
  }
}

interface IOrderPayload {
  id: number
  auto_renew: boolean
}

interface SubscriptionSuccessResponse {
  subscription_id: string
  full_phone_number: string
  email: string
  first_name: string
  last_name: string
  status: string
}

interface SubscriptionErrorResponse {
  error: string
}

export interface IFeature {
  text: string
  available: boolean
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
    navigation: any;
    id: string;
    // Customizable Area Start
    // Customizable Area End
}

interface S {
  // Customizable Area Start
  isLoading: boolean
  isAutoRenewal: boolean;
  isInfoDialog: boolean;
  infoType: InfoType
  infoMessage: string
  infoDescription: string
  orderDetails: IOrderDetails | null
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class OrderReviewController extends BlockComponent<
  Props,
  S,
  SS
> {
    // Customizable Area Start
    subscriptionPaymentApiCallId: string = ""
    infoDialogCallback: null | (() => void) = null
    // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.NavigationPayLoadMessage)
    ];

    this.state = {
      isLoading: false,
      isAutoRenewal: false,
      isInfoDialog: false,
      infoType: "success",
      infoMessage: "",
      infoDescription: "",
      orderDetails: null
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }
  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    scrollToTop()
    this.handleCheckOrder()
    const isAuth = await isAuthenticated(this.handlePageRedirection);
    if (!isAuth) return

    this.initiateRazorpaySDK()
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
      const data = message.getData(getName(MessageEnum.SessionResponseData));
      this.setState({ orderDetails: data.order })
    }

    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    )

    if(responseJson) {
      if(apiRequestCallId === this.subscriptionPaymentApiCallId) {
        this.handleSubscriptionApiResponse(responseJson)
      }
    }
    // Customizable Area End
  }
  
  // Customizable Area Start
  handleCheckOrder = async () => {
    this.setState({ isLoading: true })
    setTimeout(() => {
      if(!this.state.orderDetails) {
        this.handleRedirection("Home")
        return
      }
      this.setState({ isLoading: false })
    }, 700)
  }

  initiateRazorpaySDK = () => {
    const existingScript = document.querySelector(`script[src='${configJSON.RAZORPAY_CHECKOUT_SCRIPT}']`);
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement("script");
    script.src = configJSON.RAZORPAY_CHECKOUT_SCRIPT;
    script.async = true;
    document.body.appendChild(script)
  }

  handleRedirection = (path: string) => {
    const msg = new Message(getName(MessageEnum.NavigationMessage));
    msg.addData(getName(MessageEnum.NavigationTargetMessage), path);
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  };

  CustomUncheckedIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect stroke="#94A3B8" width="19" height="19" rx="5.5" x="0.5" y="0.5" />
    </svg>
  );

  CustomCheckedIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#652784" width="20" height="20" rx="6" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0611 5.42238C15.5183 5.73229 15.6376 6.35411 15.3277 6.81124L10.2432 14.3112C10.0771 14.5562 9.8111 14.715 9.51671 14.745C9.22232 14.7749 8.92977 14.673 8.71777 14.4665L4.80234 10.6536C4.40667 10.2683 4.39827 9.6352 4.78358 9.23953C5.16888 8.84386 5.80199 8.83546 6.19766 9.22077L9.25771 12.2007L13.6723 5.68895C13.9822 5.23182 14.604 5.11247 15.0611 5.42238Z" fill="white" />
    </svg>
  );

  handleAutoRenewalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({ isAutoRenewal: event.target.checked });
  };

  openInfoDialog = (
    infoType: InfoType,
    infoMessage: string,
    infoDescription: string = ""
  ) => {
    this.setState({ isInfoDialog: true, infoType, infoMessage, infoDescription, isLoading: false })
  }
  
  closeInfoDialog = () => {
    this.setState({ isInfoDialog: false }, () => {
      this.setState({ infoMessage: "", infoDescription: "" })
      if(this.infoDialogCallback) {
        this.infoDialogCallback()
      }
    })
  }

  handlePageRedirection = (path: string) => {
    const navigation = new Message(getName(MessageEnum.NavigationMessage));
    navigation.addData(getName(MessageEnum.NavigationTargetMessage), path);
    navigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(navigation);
  }

  getSubscriptionPaymentApi = async (httpBody: IOrderPayload) => {
    const token = await getStorageData(configJSON.TOKEN)

    const header = {
      "Content-Type": configJSON.apiContentType,
      token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.subscriptionPaymentApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.subscriptionPaymentApiEndpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handlePayNow = () => {
    const { isAutoRenewal, orderDetails } = this.state
    if(orderDetails) {
      this.setState({ isLoading: true })
      const httpBody = {
        id: orderDetails.attributes.subscription.id,
        auto_renew: isAutoRenewal
      }
      this.getSubscriptionPaymentApi(httpBody)
    }
  }

  safeCloseRazorpayModal = () => {
    document
      .querySelectorAll(
        ".razorpay-container, .razorpay-backdrop, iframe[src*='razorpay']"
      )
      .forEach((el) => el.remove());
    this.initiateRazorpaySDK();
  }  

  handleSubscriptionApiResponse = async (
    responseJson: SubscriptionSuccessResponse | SubscriptionErrorResponse
  ) => {
    try {
      if ("error" in responseJson) {
        this.openInfoDialog(
          "error",
          configJSON.paymentFailedMessage,
          responseJson.error
        )
        return
      }
      const { email, first_name, full_phone_number, last_name, subscription_id } =
        responseJson
      const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY!
  
      const options = {
        key: RAZORPAY_KEY,
        subscription_id,
        name: configJSON.companyNameText,
        description: configJSON.subscriptionPremiumDescription,
        prefill: {
          name: `${first_name} ${last_name}`,
          email,
          contact: full_phone_number,
        },
        theme: { color: configJSON.themeColor },
        handler: this.handleSuccessfulPayment,
      }
  
      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", (paymentError: RazorpayPaymentFailedResponse) => {
        rzp.close()
        this.safeCloseRazorpayModal()
        this.openInfoDialog(
          "error",
          configJSON.paymentFailedMessage,
          paymentError.error.description
        )
      })
  
      rzp.open();
      this.setState({ isLoading: false })
    } catch (error) {
      this.openInfoDialog(
        "error",
        configJSON.paymentFailedMessage,
        error as string
      )
    }
  }
  
  handleSuccessfulPayment = (_paymentResponse: RazorpayResponse) => {
    this.infoDialogCallback = () => this.handlePageRedirection("MyPlans")
    this.openInfoDialog(
      "success",
      configJSON.thankYoyForOrderMessage,
      configJSON.subscriptionNowActiveMessage
    )
  } 
  // Customizable Area End
}